import { render } from "./TableRow.vue?vue&type=template&id=34889654&scoped=true&ts=true"
import script from "./TableRow.vue?vue&type=script&lang=ts"
export * from "./TableRow.vue?vue&type=script&lang=ts"

import "./table-row.scss?vue&type=style&index=0&id=34889654&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34889654"]])

export default __exports__